import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import CourseHero from './components/CourseHero';
import ModulesSection from './components/ModulesSection';
import IncludesSection from './components/IncludesSection';
import ForWhoSection from './components/ForWhoSection';
import BonusSection from './components/BonusSection';
import CourseTestimonials from './components/CourseTestimonials';
import GuaranteeSection from './components/GuaranteeSection';
import FinalCTASection from './components/FinalCTASection';
import CourseFAQSection from './components/CourseFAQSection';
import SchemaOrg from '../../components/base/SchemaOrg';
import { faqItems } from '../../mocks/faq';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const courseSchema = {
  '@context': 'https://schema.org',
  '@type': 'Course',
  name: 'ChatGPT e Gemini para Professores',
  description:
    'Formação prática de professores em Inteligência Artificial com ChatGPT e Gemini. Aprenda a usar IA no planejamento, criação de materiais, avaliação e documentação pedagógica.',
  url: siteUrl,
  provider: {
    '@type': 'Organization',
    name: 'ViaEducacaoCursos',
    url: siteUrl,
  },
  educationalLevel: 'Educação Básica',
  inLanguage: 'pt-BR',
  hasCourseInstance: {
    '@type': 'CourseInstance',
    courseMode: 'online',
    inLanguage: 'pt-BR',
  },
  offers: {
    '@type': 'Offer',
    price: '147.00',
    priceCurrency: 'BRL',
    url: 'https://pay.hotmart.com/W100719375C?off=w6t3o2lu',
    availability: 'https://schema.org/InStock',
    seller: {
      '@type': 'Organization',
      name: 'ViaEducacaoCursos',
    },
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqItems.map((item) => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer,
    },
  })),
};

const OG_IMAGE = 'https://public.readdy.ai/ai/img_res/9f047cc7a17db0eba9e273c0a2084a95.jpg';
const OG_TITLE = 'Curso ChatGPT e Gemini para Professores | ViaEducacaoCursos';
const OG_DESCRIPTION = 'Domine a Inteligência Artificial na educação em 8 módulos práticos. Inclui materiais prontos, 3 agentes de IA exclusivos e suporte via WhatsApp. Garantia incondicional de 15 dias. Por R$ 147,00.';

export default function CursoDetalhadoPage() {
  useEffect(() => {
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'ViewContent', {
        content_name: 'Curso ChatGPT e Gemini para Professores',
        content_category: 'Curso',
        content_ids: ['curso-chatgpt-gemini'],
        content_type: 'product',
        value: 147.00,
        currency: 'BRL',
      });
    }
  }, []);

  const pageUrl = `${siteUrl}/curso-detalhado`;

  return (
    <div className="min-h-screen">
      {/* Open Graph + Twitter Card */}
      <title>{OG_TITLE}</title>
      <meta name="description" content={OG_DESCRIPTION} />

      {/* Open Graph */}
      <meta property="og:type" content="product" />
      <meta property="og:title" content={OG_TITLE} />
      <meta property="og:description" content={OG_DESCRIPTION} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content="Curso ChatGPT e Gemini para Professores — ViaEducacaoCursos" />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:site_name" content="ViaEducacaoCursos" />
      <meta property="og:locale" content="pt_BR" />
      <meta property="product:price:amount" content="147.00" />
      <meta property="product:price:currency" content="BRL" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={OG_TITLE} />
      <meta name="twitter:description" content={OG_DESCRIPTION} />
      <meta name="twitter:image" content={OG_IMAGE} />
      <meta name="twitter:image:alt" content="Curso ChatGPT e Gemini para Professores — ViaEducacaoCursos" />

      {/* WhatsApp usa og:image — reforço do tamanho mínimo recomendado */}
      <link rel="canonical" href={pageUrl} />

      <SchemaOrg id="curso-detalhado" schema={courseSchema} />
      <SchemaOrg id="curso-detalhado-faq" schema={faqSchema} />
      <Navbar />
      <main>
        <CourseHero />
        <ModulesSection />
        <IncludesSection />
        <ForWhoSection />
        <BonusSection />
        <CourseTestimonials />
        <GuaranteeSection />
        <CourseFAQSection />
        <FinalCTASection />
      </main>
      <Footer />
    </div>
  );
}
